import get from "lodash/get"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { minorAlertNotVisible } from "actions-lib"
import GlobalNotifications from "./GlobalNotifications"

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      minorAlertNotVisible,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state) => ({
  alert: state.alert,
  state: get(state, `customerSelections.customerAddress.state`, ``),
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalNotifications)
